import { render, staticRenderFns } from "./_TemplatePreview.vue?vue&type=template&id=4fa6ace6&scoped=true&"
import script from "./_TemplatePreview.vue?vue&type=script&lang=ts&"
export * from "./_TemplatePreview.vue?vue&type=script&lang=ts&"
import style0 from "./_TemplatePreview.vue?vue&type=style&index=0&id=4fa6ace6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa6ace6",
  null
  
)

export default component.exports